/* eslint-disable react/prop-types */
import { Button, Checkbox, FormControl, FormControlLabel, FormGroup, Radio, RadioGroup } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRoomContext } from '../../../../RoomContext';
import * as appPropTypes from '../../../../components/appPropTypes';
import '../styles.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as toolareaActions from '../../../../store/actions/toolareaActions';
import GradientButton from '../../../customMui/newButton/newButton';
import DotSpin from '../../../Loader/dotSpin';
import axios from 'axios';
import { engagementInsightandFeature } from '../../../../libs/apis/analyticsApi';

function NewPollingDialog(props)
{

	const {
		currentPollingData,
		myId,
		handlePollingDialogue,
		roomClient,
		myData,
		webinarData
	} = props;

	const intl = useIntl();
	// const [ open, setOpen ] = useState(true);
	const [ singleChoiceValue, setSingleChoiceValue ] = useState(null);
	const [ singleChoiceIndex, setSingleChoiceIndex ] = useState(null);
	const [ multiChoiceIndexes, setMultiChoiceIndexes ] = useState([ ]);
	const [ alreadySubmit, setAlreadySubmit ] = useState(false);
	const [ alreadySubmitInd, setAlreadySubmitInd ] = useState(null);
	const [ multiState, setMultiState ] = useState({});
	const [ isLoading, setIsLoading ]= useState(false);
	// const [ multiCheckedItems, setMultiCheckedItems ] = useState({});

	useEffect(() =>
	{
		if (currentPollingData?.questionType === 'multi')
		{
			const newObj = {};

			for (const index in currentPollingData?.options)
			{
				if (index)
				{
					newObj[Number(index)] = false;
				}

			}
			setMultiState(newObj);
		}
	}, []);

	useEffect(() =>
	{

		setIsLoading(true);
		axios.get(`${import.meta.env.VITE_USERS}/getPeerPollResult/${currentPollingData?._id}/${myId}`)
			.then((response) =>
			{

				if (response.data.status)
				{
					if (currentPollingData?.questionType === 'multi')
					{
						const newObj = {};

						const subOptions = [ ...response?.data?.data?.subOptions ];

						// eslint-disable-next-line guard-for-in
						for (const index in currentPollingData?.options)
						{
							if (subOptions.includes(Number(index)))
							{

								newObj[Number(index)] = true;
							}
							else
							{
								newObj[Number(index)] = false;
							}
						}

						setMultiState(newObj);
						setMultiChoiceIndexes(response.data.data.subOptions);
						setAlreadySubmitInd(subOptions);
					}
					else if (currentPollingData?.questionType === 'single')
					{
						// eslint-disable-next-line max-len
						setSingleChoiceValue(currentPollingData?.options?.[response.data.data.subOptions[0]]);
						setSingleChoiceIndex(response.data.data.subOptions[0]);
						setAlreadySubmitInd(response.data.data.subOptions[0]);
					}
					setAlreadySubmit(true);

				}
				setIsLoading(false);
			})
			.catch(() =>
			{
				// if (currentPollingData?.questionType === 'multi')
				// {
				// 	const newObj = {};

				// 	for (const index in currentPollingData?.options)
				// 	{
				// 		if (currentPollingData?.options?.length < index)
				// 		{
				// 			newObj[index] = false;
				// 		}
				// 	}
				// 	setMultiState(newObj);
				// 	setMultiChoiceIndexes([]);
				// }
				// else if (currentPollingData?.questionType === 'single')
				// {
				// }

				setSingleChoiceValue(null);
				setSingleChoiceIndex(null);
				setAlreadySubmitInd(null);
				setAlreadySubmit(false);
				// toast.error(error?.message);
				setIsLoading(false);
			});

	}, [ currentPollingData ]);

	console.log('weeeeeeeeeeeeeeeeee', webinarData);

	const pollSubmit = async () =>
	{
		const pollData= {
			licenseTo           : webinarData?.licenseDetails?.licenseObj?.licenseTo,
			meetingId           : webinarData?._id,
			sessionId           : webinarData?.sessionId,
			scheduledBy         : webinarData?.scheduledBy,
			startTimeUTC        : webinarData?.startTimeUTC,
			endTimeUTC          : webinarData?.endTimeUTC,
			scheduleType        : webinarData?.scheduleType,
			isEngagementInsight : true,
			isMostUsedFeature   : false,
			polls               : true,
			handraise           : false,
			emojis              : false
		};

		await engagementInsightandFeature(pollData)
			.then((response) =>
			{
				console.log('poll insight submit API response:', response);
			})
			.catch((error) =>
			{
				console.error('Error while calling poll insight API:', error);
			});
	};

	const handleVote = () =>
	{

		// eslint-disable-next-line no-console
		if (singleChoiceIndex !== null || multiChoiceIndexes.length > 0)
		{
			const body = { userId: myId, userName: myData?.displayName, userEmail: myData?.email, userProfilePicKey: myData?.picture };

			if (currentPollingData?.questionType === 'multi')
			{
				body['subOptions'] = multiChoiceIndexes;
			}
			else if (currentPollingData?.questionType === 'single')
			{
				body['subOptions'] = [ singleChoiceIndex ];
			}
			setIsLoading(true);
			axios.post(`${import.meta.env.VITE_USERS}/pollsubmit/${currentPollingData?.meetingId}/${currentPollingData?.sessionId}/${currentPollingData?._id}`, body)
				.then((response) =>
				{

					if (response.data.status)
					{
						pollSubmit();
						if (currentPollingData?.questionType === 'multi')
						{

							// eslint-disable-next-line max-len
							roomClient.peerPollSubmit({ pollId: currentPollingData?._id, sessionId: currentPollingData?.sessionId, questionType: 'multi', index: multiChoiceIndexes.sort(), userId: myId, alreadySubmit: alreadySubmit, alreadySubmitInd: alreadySubmitInd?.sort() });
							setTimeout(() =>
							{
								setAlreadySubmit(false);
								setAlreadySubmitInd(null);
								setIsLoading(false);
								handlePollingDialogue(false);
								// setOpen(false);
							}, 1000);
						}
						else if (currentPollingData?.questionType === 'single')
						{

							// eslint-disable-next-line max-len
							roomClient.peerPollSubmit({ pollId: currentPollingData?._id, sessionId: currentPollingData?.sessionId, questionType: 'single', index: singleChoiceIndex, userId: myId, alreadySubmit: alreadySubmit, alreadySubmitInd: alreadySubmitInd });
							setTimeout(() =>
							{
								setSingleChoiceValue(null);
								setSingleChoiceIndex(null);
								setAlreadySubmit(false);
								setAlreadySubmitInd(null);
								setIsLoading(false);
								handlePollingDialogue(false);
								// setOpen(false);
							}, 1000);
						}
						toast.success(intl.formatMessage({ id: 'poll_succefully_submitted', defaultMessage: 'You’ve successfully submitted the poll!' }));
					}
				})
				.catch((error) =>
				{

					toast.error(error?.response?.data?.err);
					setIsLoading(false);
				});
		}
		else
		{
			toast.error(intl.formatMessage({ id: 'please_select_option_submit', defaultMessage: 'Please select an option to submit!' }));
		}
	};

	// const question = {
	// 	question : 'Is this App useful ?',
	// 	options  : [ 'Yes', 'No' ]
	// };

	const handleClose = () =>
	{
		// setOpen(false);
		handlePollingDialogue(false);
	};

	const handleSingleChoiceValue = (event, value) =>
	{
		event.persist();

		setSingleChoiceValue(value);
	};

	const handleChoiceIndex = (event, index) =>
	{
		event.preventDefault();

		if (currentPollingData?.questionType === 'single')
		{
			setSingleChoiceIndex(index);
		}
	};

	const handleCheckboxChange = (event, index) =>
	{
		setMultiState({
			...multiState,
			[index] : event.target.checked
		});
		const isChecked = event.target.checked;

		if (isChecked)
		{
			setMultiChoiceIndexes((prevIndexes) => [ ...prevIndexes, index ]);
		}
		else
		{
			setMultiChoiceIndexes((prevIndexes) =>
				prevIndexes.filter((item) => item !== index)
			);
		}
	};

	return (
		<div className='flexCol dialogBD' >
			<div className='flexCol dialogBox pdngBMD'>
				<div className='flexRow jCntr aCntr brdrBSM '>
					<div className='flexRow pdngSM aCntr jBtwn'>
						<span className='lHdng pdngHXS'>POLL</span>
						<img
							src='/images/cancel.svg'
							alt='cancel'
							className='IconImage pointer'
							onClick={handleClose}
						/>
					</div>
				</div>
				<div className='flexCol pdngMD'>
					<span className='txtBlBoldSM pdngXS capTxt breakWord'>{currentPollingData?.question}</span>
					<div className='flexCol pdngHSM'>
						{currentPollingData?.questionType === 'single' && <RadioGroup aria-label='question' name='question' value={singleChoiceValue} onChange={handleSingleChoiceValue} color='primary' className='gap16'>
							{currentPollingData?.options?.map((each, index) => (
								// eslint-disable-next-line max-len
								<FormControlLabel onChange={(event) => handleChoiceIndex(event, index)} key={index} value={each} control={<Radio color='primary' />} label={each} className='optionWordBreak '/>
							))}
						</RadioGroup>}
						{currentPollingData?.questionType === 'multi' && <FormControl component='fieldset' className='gap16 checkboxWordBreak' >
							<FormGroup>
								{currentPollingData?.options?.map((each, index) => (
									// eslint-disable-next-line max-len
									<FormControlLabel
										key={index}
										control={
											<Checkbox
												checked={multiState[index] || false}
												onChange={(event) => handleCheckboxChange(event, index)}
												color='primary'
											/>
										}
										label={each}
									/>
								))}
							</FormGroup>
						</FormControl>}
					</div>

				</div>
				<div className='flexRow aEnd jEnd gap16 pdngHLG '>
					<Button
						variant='outlined'
						color='primary'
						disableElevation
						style={{ borderRadius: '10px' }}
						className='pointer'
						size='large'
						onClick={handleClose}
					>
						Cancel
					</Button>
					<GradientButton
						variant='contained'
						disableElevation
						color='primary'
						size='large'
						disabled={isLoading}
						style={{ borderRadius: '10px' }}
						onClick={() => handleVote()}
					>
						Submit
					</GradientButton>

				</div>

			</div>

			{isLoading && <DotSpin />}
			<ToastContainer
				position='top-right'
				autoClose={3000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnVisibilityChange
				draggable
				pauseOnHover
			/>
		</div>
	);
}

// export default NewPollingDialog;

NewPollingDialog.propTypes =
{
	roomClient            : PropTypes.any.isRequired,
	peer                  : appPropTypes.Peer,
	pollingsList          : PropTypes.array,
	currentPollingData    : PropTypes.object,
	myId                  : PropTypes.string,
	handlePollingDialogue : PropTypes.func,
	myData                : PropTypes.any,
	webinarData           : PropTypes.any
};

const makeMapStateToProps = (initialState, { id }) =>
{
	const mapStateToProps = (state) =>
	{
		return {
			// peer         : state.peers[id],
			pollingsList       : state.toolarea.pollingsList,
			myId               : state.me.id,
			currentPollingData : state.toolarea.currentPollingData,
			myData             : state.me,
			webinarData        : state.webinar.webinarData
		};
	};

	return mapStateToProps;
};
const mapDispatchToProps = (dispatch) => ({
	// eslint-disable-next-line max-len
	handlePollingDialogue : (isPollOpen) => dispatch(toolareaActions.handlePollingDialogue(isPollOpen))
});

export default withRoomContext(connect(
	makeMapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.peers === next.peers &&
				prev.toolarea.pollingsList === next.toolarea.pollingsList &&
				prev.toolarea.currentPollingData === next.toolarea.currentPollingData &&
				prev.webinar.webinarData === next.webinar.webinarData
			);
		}
	}
)(NewPollingDialog));